"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCase = void 0;

var camelCase_1 = __importDefault(require("lodash/camelCase"));

var startCase_1 = __importDefault(require("lodash/startCase"));
/**
 * Converts `string` to [title case](https://en.wikipedia.org/wiki/Letter_case#Title_case).
 *
 * @export
 * @category String
 * @param {string} [input=''] The string to convert.
 * @returns {string} Returns the title cased string.
 * @see startCase, camelCase
 * @example
 *
 * ```js
 * titleCase('foo bar')
 * // => 'Foo Bar'
 *
 * titleCase('--foo-bar--')
 * // => 'Foo Bar'
 * ```
 */


function titleCase(input) {
  return startCase_1.default(camelCase_1.default(input));
}

exports.titleCase = titleCase;